export default "__VITE_ASSET__9d7a4704__"